// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1zUDC","content":"styles_content__3NzlR","checkbox":"styles_checkbox__cQVIb","checkboxLabel":"styles_checkboxLabel__3lUJm"};